<template>
    <data-table
        :id="state_identifier"
        :columns="visible_columns"
        :rows="filtered_rows"
        :search="state.search"
        :total="state.total"
        :found="state.found"
        :current-page="state.page"
        :total-pages="nb_pages"
        :show-totals="false"
        :searchable="false"
        table-class="lam-subrecords-list"
        empty-title="No projects found"
        @sort="sort_by"
        @search="search"
        @page="goto_page"
        @click="record_edit(entity, $event.id)"
        class="lam-table-cell-nowrap"
    >
        <template
            v-slot:summary="{ row }"
        >
            <h6>{{ row.name }}</h6>
        </template>
        <template
            v-slot:tbody="{ row, field }"
        >
            <span v-if="field === 'sortable_number'">{{ row.sortable_number | lam.project-number }}</span>
            <router-link
                v-else-if="field === 'name'"
                :to="{ name: `${!!row.activated_at?'project':'prospective_project'}.edit`, params: { id: row.id } }"
            >
                {{ row.name }}
            </router-link>
            <span v-else-if="field === 'role'">{{ role_for_project(row, ((context === "user") ? contextId : null)) }}</span>
            <span v-else-if="field === 'hours'">{{ row.hours | nibnut.number }}</span>
            <span v-else-if="field.match(/_(fee|spent)$/)" :class="{'uk-text-danger': row[field]<0}">$ {{ row[field] | nibnut.number("0,0.00") }}</span>
            <span v-else-if="field.match(/_at(_as_string)?$/)">{{ row[field] | nibnut.date }}</span>
            <span v-else>{{ row[field] }}</span>
       </template>
    </data-table>
</template>

<script>
import is_remote_data_table_source from "../../mixins/IsRemoteDataTableSource"
import project_utilities from "../../mixins/ProjectUtilities"

export default {
    mixins: [is_remote_data_table_source, project_utilities],
    watch: {
        active: "reset"
    },
    methods: {
        reset () {
            const new_state = {
                context: this.context,
                context_id: this.contextId,
                activated_at: !!this.active
            }
            if(!this.state.sort_by || (!this.active && (this.state.sort_by === "sortable_number"))) {
                new_state.sort_by = this.active ? "sortable_number" : "name"
                new_state.sort_dir = this.active ? "desc" : "asc"
            }
            this.set_state_values(new_state)
            this.refresh()
        }
    },
    computed: {
        state_identifier () {
            return this.id
        },
        rows () {
            return this.$store.getters.entity_records(this.entity, this.current_records_ids).filter(row => {
                if(this.context === "firm") return row.firm_ids.indexOf(this.contextId) >= 0
                if(this.context === "contact") return row.contact_ids.indexOf(this.contextId) >= 0
                return (this.contextId === row.pic_id) || (this.contextId === row.pm_id) || (row.designer_ids.indexOf(this.contextId) >= 0)
            })
        },
        visible_columns () {
            const columns = {}

            if(this.active) columns.sortable_number = this.columns.sortable_number
            columns.name = this.columns.name
            if(this.context === "user") {
                columns.role = this.columns.role
                if(this.active) columns.hours = this.columns.hours
            } else if(this.context === "firm") {
                columns.computed_fee = this.columns.computed_fee
                columns.computed_spent = this.columns.computed_spent
                columns.computed_starts_at_as_string = this.columns.computed_starts_at_as_string
                columns.computed_ends_at_as_string = this.columns.computed_ends_at_as_string
            }

            return columns
        }
    },
    props: {
        id: {
            type: String,
            required: true
        },
        context: {
            type: String,
            required: true
        },
        contextId: {
            type: Number,
            required: true
        },
        active: {
            type: Boolean,
            default: true
        },
        sublist: {
            type: Boolean,
            default: true
        },
        noWrap: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            entity: "project",
            columns: {
                sortable_number: { label: "Number", sort: null, type: "plain", cell_class: "lam-col-number" },
                name: { label: "Project", sort: null, type: "plain", cell_class: "lam-col-project-name" },
                role: { label: "Capacity", sort: false, type: "plain", cell_class: "lam-col-user-initials" },
                hours: { label: "Hours", sort: null, type: "plain", cell_class: "lam-col-hours" },
                pic_id: { label: "PIC", sort: false, type: "plain", cell_class: "lam-col-user-initials" },
                pm_id: { label: "PM", sort: false, type: "plain", cell_class: "lam-col-user-initials" },
                computed_fee: { label: "Fee", sort: null, type: "plain" },
                computed_spent: { label: "Spent", sort: null, type: "plain" },
                computed_starts_at_as_string: { label: "Starts", sort: null, type: "plain", head_class: "uk-text-center", cell_class: "uk-text-center" },
                computed_ends_at_as_string: { label: "Ends", sort: null, type: "plain", head_class: "uk-text-center", cell_class: "uk-text-center" },

                designer_ids: { label: "Designers", sort: false, type: "plain" },
                firm_ids: { label: "Firms", sort: false, type: "plain" },
                contact_ids: { label: "Firms", sort: false, type: "plain" }
            },
            default_state: {
                per_page: 10,
                page: 1,
                sort_by: null,
                sort_dir: null,
                filter_on: null,
                filter: "",
                archived: false,
                search: "",
                total: 0,
                found: 0,
                context: "",
                context_id: 0,
                activated_at: 0
            }
        }
    }
}
</script>
